import { render } from "./comments.vue?vue&type=template&id=73a7d120&scoped=true"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"

import "./comments.vue?vue&type=style&index=0&id=73a7d120&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a7d120"]])

export default __exports__